import React from "react"
import PropTypes from "prop-types"
import Tooltip from "@mui/material/Tooltip"
import ClickAwayListener from "@mui/material/ClickAwayListener"
import Button from "@mui/material/Button"
import { makeStyles } from "tss-react/mui"

// const styles = () => ({
const useStyles = makeStyles()(() => ({
    tooltip: {
        fontSize: 16,
    },
    span: {
        border: "1px black",
    },
}))

const Footnote = ({ children, note }) => {
    const { classes } = useStyles()
    const [open, setOpen] = React.useState(false)

    const handleTooltipClose = () => {
        setOpen(false)
    }

    const handleTooltipOpen = () => {
        setOpen(true)
    }

    return (
        <ClickAwayListener onClickAway={handleTooltipClose}>
            <div
                style={{
                    display: "inline-block",
                }}
            >
                <Tooltip
                    PopperProps={{
                        disablePortal: true,
                    }}
                    classes={{ tooltip: classes.tooltip }}
                    onClose={handleTooltipClose}
                    open={open}
                    disableFocusListener
                    disableHoverListener
                    disableTouchListener
                    title={note}
                >
                    <span
                        onClick={handleTooltipOpen}
                        style={{
                            borderBottom: "2px black",
                            borderBottomStyle: "dotted",
                            cursor: "pointer",
                        }}
                    >
                        {children}
                    </span>
                </Tooltip>
            </div>
        </ClickAwayListener>
    )
}

Footnote.propTypes = {
    // classes: PropTypes.object.isRequired,
    note: PropTypes.string,
    children: PropTypes.node,
}

export default Footnote
